
<div class="card">
    <div class="card-header">
        <h4>Add Service Provider</h4>
    </div>
    <div class="row">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link" [class.active]="activeTab === 'service'">Basic Information</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" [class.active]="activeTab === 'commission'">Commission Setup</a>
            </li>
          </ul>
    </div>

    <div class="tab-content pt-2" id="myTabContent">
         <div id="service" class="tab-pane fade p-4 active show" [ngStyle]="{ 'display': activeTab === 'service'? 'block' : 'none'}">
          <form #addServiceProvider="ngForm" (ngSubmit)="saveServiceProvider(addServiceProvider.value)" [formGroup]="addServiceProviderForm">
            <div class="row">
                <div class="col-lg-12">
                  <div class="card border-0 shadow-none text-center">
                    <div class="card-body">
                      <div class="row d-flex">
                        <div class="form-group col-md-3">
                          <label class="col-form-label" for="serviceProviderName">Service Provider Name <span aria-hidden="true"
                                  class="symbol required" style="color:red;">*</span>
                          </label>
                          <input type="text" id="serviceProviderName" autocomplete="off" class="form-control" (paste)="onPaste($event)" (keypress)="OnlyCharacterAllowed($event)" required formControlName="serviceProviderName" placeholder="Enter Service Provider Name" [ngClass]="{'is-invalid':submitted && addServiceProviderForm.controls.serviceProviderName.errors}"  name="serviceProviderName">
                          <div class="invalid-feedback">
                              Service Provider Name is required
                            </div>
                        </div>
                        <div class="form-group col-md-3">
                          <label class="col-form-label" for="serviceProviderDesc">Service Provider Description <span aria-hidden="true"
                                  class="symbol required" style="color:red;">*</span>
                          </label>
                          <input type="text" id="serviceProviderDesc" autocomplete="off" class="form-control" (paste)="onPaste($event)"  (keypress)="OnlyCharacterAllowed($event)"  required formControlName="serviceProviderDesc" placeholder="Enter Service Provider Description" [ngClass]="{'is-invalid':submitted && addServiceProviderForm.controls.serviceProviderDesc.errors}"  name="serviceProviderDesc">
                          <div class="invalid-feedback">
                              Service Provider Description is required
                            </div>
                        </div>
                        <div class="form-group col-md-3">
                          <label class="col-form-label" for="serviceProviderCode">Service Provider Code <span aria-hidden="true"
                                  class="symbol required" style="color:red;">*</span>
                          </label>
                          <input type="text" id="serviceProviderCode" autocomplete="off" class="form-control" (paste)="onPaste($event)"  (keypress)="OnlyCharacterAllowed($event)"  required formControlName="serviceProviderCode" placeholder="Enter Service Provider Code" [ngClass]="{'is-invalid':submitted && addServiceProviderForm.controls.serviceProviderCode.errors}"  name="serviceProviderCode">
                          <div class="invalid-feedback">
                              Service Provider Code is required
                            </div>
                        </div>
                        <div class="form-group col-md-3">
                          <label class="col-form-label" for="contactNumber">Contact Number <span aria-hidden="true"
                                  class="symbol required" style="color:red;">*</span>
                          </label>
                          <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <select class="form-control" id="contactCountryCode" formControlName="contactCountryCode" name="contactCountryCode" required >
                                  <option *ngFor="let country of countryDropDown" [value]="country.phoneCode">+{{country.phoneCode}}</option>
                                </select>
                            </div>
                            <input type="text" class="form-control" (paste)="onPaste($event)"  autocomplete="off" id="phone" required placeholder="Enter Contact Number" maxlength="10"
                                formControlName="contactNumber" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                                [ngClass]="{'is-invalid': submitted && addServiceProviderFormControl.contactNumber.errors}">
                        </div>
                          <div class="invalid-feedback" style="display: block;"
                           *ngIf="submitted && addServiceProviderFormControl?.contactNumber?.errors">
                            <div *ngIf="addServiceProviderFormControl?.contactNumber?.errors?.required">
                                Contact Number is required.
                            </div>
                            <div *ngIf="addServiceProviderFormControl?.contactNumber?.errors?.pattern">
                              Please enter valid contact number.
                          </div>
                        </div>
                        <div class="invalid-feedback" style="display: block;" *ngIf="submitted && addServiceProviderFormControl?.contactCountryCode?.errors">
                          <div *ngIf="addServiceProviderFormControl?.contactCountryCode?.errors?.required">
                            Country Code is required.
                        </div>
                      </div>
                          
                      </div>
                        
                      </div>
                      <div class="row d-flex">
                        <div class="form-group col-md-3">
                          <label class="col-form-label" for="country">Country <span aria-hidden="true"
                                  class="symbol required" style="color:red;">*</span>
                          </label>                      
                          <ng-select id="country" [items]="countryDropDown" bindLabel="name" bindValue="id" placeholder="Select Country"  formControlName="country" name="country"  required  [ngClass]="{'is-invalid':submitted && addServiceProviderForm.controls.country.errors}" >
                          </ng-select>   
                          <div class="invalid-feedback" >
                              <div>
                                  Country is required.
                              </div>
                          </div>
                      </div>
                        <div class="form-group col-md-3">
                            <label class="col-form-label" for="emailId">Email ID <span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                            <input type="text" id="emailId" autocomplete="off" (paste)="onPaste($event)" class="form-control" required formControlName="emailId" placeholder="Enter Email ID" [ngClass]="{'is-invalid':submitted && addServiceProviderForm.controls.emailId.errors}"  name="emailId">
                            <div class="invalid-feedback" style="display: block;"
                            *ngIf="submitted && addServiceProviderFormControl?.emailId?.errors">
                             <div *ngIf="addServiceProviderFormControl?.emailId?.errors?.required">
                                 Email Id is required.
                             </div>
                             <div *ngIf="addServiceProviderFormControl?.emailId?.errors?.pattern">
                               Please enter valid email id.
                           </div>
                         </div>
                        </div>
                        <!-- <div class="form-group col-md-3">
                            <label class="col-form-label" for="status">Status <span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                            <ng-select formControlName="status" placeholder="Select Status" id="status" name="status" required  [ngClass]="{'is-invalid':submitted && addServiceProviderForm.controls.status.errors}" >
                                <ng-option value="Active">Active</ng-option>
                                <ng-option value="Inactive">Inactive</ng-option>
                              </ng-select>
                            <div class="invalid-feedback" >
                                <div >
                                    Status is required.
                                </div>
                            </div>
                        </div> -->
                        <div class="form-group col-md-3">
                          <label class="col-form-label" for="maxBalance">Maximum Balance <span aria-hidden="true"
                                  class="symbol required" style="color:red;">*</span>
                          </label>
                          <input type="text" id="maxBalance" autocomplete="off" maxlength="8" class="form-control" required formControlName="maxBalance" placeholder="Enter Maximum Balance" [ngClass]="{'is-invalid':submitted && addServiceProviderForm.controls.maxBalance.errors}"  name="maxBalance" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                              Maximum Balance is required
                            </div>
                        </div>
                         
                      </div>
                      <div class="row d-flex">
                        
                          <div class="form-group col-md-3">
                              <label class="col-form-label" for="category">Category <span aria-hidden="true"
                                      class="symbol required" style="color:red;">*</span>
                              </label>
                              <ng-select [items]="categoryDropDown" placeholder="Select Category" bindLabel="name" (change)="categoryChange($event)" id="category" formControlName="category" required  [ngClass]="{'is-invalid':submitted && addServiceProviderForm.controls.category.errors}"  name="category">
                              </ng-select>
                              
                              <div class="invalid-feedback" >
                                  <div >
                                    Category is required.
                                  </div>
                              </div>
                          </div>
                          <div class="form-group col-md-3">
                            <label class="col-form-label" for="subCategory">Sub Category <span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                            <ng-select [items]="subCategoryDropDown" placeholder="Select Subcategory" bindLabel="name" (change)="subCategoryChange($event)" id="subCategory" formControlName="subCategory" required  [ngClass]="{'is-invalid':submitted && addServiceProviderForm.controls.subCategory.errors}"  name="subCategory">
                            </ng-select>
                            <div class="invalid-feedback" >
                                <div >
                                  Sub Category is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-3">
                            <label class="col-form-label" for="product">Product <span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                            <ng-select [items]="productDropDown" placeholder="Select Product" bindLabel="name" id="id" formControlName="product" required  [ngClass]="{'is-invalid':submitted && addServiceProviderForm.controls.product.errors}"  name="product">

                              </ng-select>
                            <div class="invalid-feedback" >
                                <div >
                                    Product is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-3" style="margin-top:40px;">
                          <button type="button" (click)="addProduct()" class="btn btn-primary">Add Product</button>
                      </div>
                      </div>
                    
                    <br>
                      <div class="row d-flex" >
                        
                        <div class="form-group col-md-4" *ngFor="let productData of productTableList;let i=index">
                          <div  class="card border-light cards" >
                            <div class="row">
                                <div class="col-sm-4 mt-4">
                                    <img [src]="productTableList[i].productIcon" style="width: 95%;"  alt="Card image cap" class="card-img-top">
                                </div>
                                <div class="col-sm-8">
                                    <div class="card-header position-relative">
                                        <h5>{{productTableList[i].productName}}</h5>
                                        <button type="button" (click)="deleteProduct(i)" class="close" aria-label="Close">
                                            <i class="fa fa-times-circle" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div class="card-body">
                                        <p class="card-text" style="font-size: 10px;">{{productTableList[i].categoryName}} | {{productTableList[i].subCategoryName}}</p>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                        
                    </div>
                      <div class="row">
                          <div class="form-group col-md-12 text-right">
                              <button type="submit" class="btn btn-primary">Save & Next</button>
                              <button type="button" class="btn btn-secondary" id="cancelButton" (click)="cancelButton()">Cancel</button>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> 
            </form>
         </div>
         <div id="commission" class="tab-pane fade p-4 active show" [ngStyle]="{ 'display': activeTab === 'commission'? 'block' : 'none'}">
          <form #addCommission="ngForm" (ngSubmit)="saveCommission(addCommission.value)" [formGroup]="addCommissionForm">
            <div class="row">
                <div class="col-lg-12">
                  <div class="card border-0 shadow-none text-center">
                    <div class="card-body">
                      <div class="row d-flex">
                        <div class="form-group col-md-4">
                            <ng-select id="product" (change)="productChange($event)" placeholder="Select Product" [items]="productTableList" bindLabel="productName" bindValue="id" formControlName="product" required placeholder="Select Product" [ngClass]="{'is-invalid':submittedCommission && addCommissionForm.controls.product.errors}" name="product" >
                        </ng-select>   
                            <div class="invalid-feedback" >
                                <div>
                                    Product | Category | Subcategory is required.
                                </div>
                            </div>
                        </div>
                          
                      </div>
                      <br>
                      <div class="row d-flex" *ngIf="showDataTable">
                          <div class="form-group col-md-4">
                            <h5 class="col-form-label" for="fullName">{{selectedProduct.productName}} | {{selectedProduct.categoryName}} | {{selectedProduct.subCategoryName}}</h5>
                          </div>
                          <div class="form-group col-md-5">
                              
                          </div>
                          <div class="row d-flex">
                            <div class="text-right">
                                  <button type="button" class="btn btn-primary" (click)="addRow()">Add Slab</button>
                                  <button type="button" class="btn btn-primary"  (click)="selectSpecificAmount()">Add Specific Amount</button>
                                  <button type="button" class="btn btn-secondary" id="cancelButton" (click)="clearButton()">Clear</button>
                                
                            </div> 
                          </div> 
                    </div>
                    <div class="row d-flex" *ngIf="showDataTable">
                      <div class="row mb-0" style="min-height: 270px">
                        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                          <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" (cellValueChanged)="onCellValueChanged($event)"
                            [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                             [rowData]="finalCommissionData" [rowModelType]="" [rowSelection]="'single'"
                            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                          </ag-grid-angular>
                        </div>
                      </div>

                    </div>
                    <br>
                    <div class="row d-flex" *ngIf="showDataTable">
                      <div class="form-group col-md-9"></div>
                      <div class="form-group col-md-3">
                        <button type="submit" class="btn btn-primary" >Save</button>
                        <button type="button" class="btn btn-secondary" id="cancelButton" (click)="cancelButton()">Cancel</button>
                      </div>
                    </div>

                  </div>
                </div>
              </div> 
         </div>
        </form>
    </div>  
</div>